module.exports = __webpack_public_path__ + "img/QR-Pass.257ecf60.png";